// extracted by mini-css-extract-plugin
export default {"error":"Message_error__EJILK","success":"Message_success__doHhL"};